
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 2H1v10h15V2z","fill":"#fff","fill-opacity":".3"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3 14a1 1 0 011-1h16a1 1 0 110 2H4a1 1 0 01-1-1zM3 19a1 1 0 011-1h8a1 1 0 110 2H4a1 1 0 01-1-1zM3 5a1 1 0 011-1h16a1 1 0 011 1v4a1 1 0 01-1 1H4a1 1 0 01-1-1V5zm2 1v2h14V6H5z","fill":"#FDFDFD"}}),_c('mask',{attrs:{"id":"a","fill":"#fff"}},[_c('path',{attrs:{"d":"M3 5a1 1 0 011-1h16a1 1 0 011 1v4a1 1 0 01-1 1H4a1 1 0 01-1-1V5z"}})]),_c('path',{attrs:{"d":"M4 4v2h16V2H4v2zm17 1h-2v4h4V5h-2zm-1 5V8H4v4h16v-2zM3 9h2V5H1v4h2zm1 1V8a1 1 0 011 1H1a3 3 0 003 3v-2zm17-1h-2a1 1 0 011-1v4a3 3 0 003-3h-2zm-1-5v2a1 1 0 01-1-1h4a3 3 0 00-3-3v2zM4 4V2a3 3 0 00-3 3h4a1 1 0 01-1 1V4z","fill":"#FDFDFD","mask":"url(#a)"}})])
          )
        }
      }
    